// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1TuZh","footer":"Form_footer__5lzQ-"};